import React from "react";
import styles from "./styles/CloseButton.module.css";
import { ReactComponent as IconXmark } from "../../../assets/xmark.svg";
/**
 * Customizable button component
 * can be used as a standard close button or as a tab close button
 */
const CloseButton = ({
    size, // {String} - The size of the button, can be adapt, small or adapt
    // the adapt will make the component inherit the font size from parent element
    tab, // {Boolean} - The flag that indicate if the button is used in a tab (POS)

    body, // {String} - The button text or content

    onClickFuction, // {Function} - The function to call on button click
    grayClicked, // {Boolean} - Flag to gray the background when disabled (CSS)
    disabled, // {Boolean} - Flag to disable the button (CSS)
    tabBackground, // {Boolean} - The background color of the tab Button is red when true
    setHoverFlag, // {Function} - Function to set the hover flag
    disableHTML, // {Boolean} - Flag to disable the button in HTML
    standardButton, // {Boolean} - Flag to enable standard close button behavier
}) => {
    /**
     * Handles custom disable button in conjunction with hoverFlag
     */
    const handleHover = (requiredFlag) => {
        setHoverFlag && setHoverFlag(requiredFlag);
    };

    return (
        <button
            className={`${tab ? styles.tab_button : styles.button_base} ${
                tabBackground ? styles.button_red : ""
            } ${
                size === "adapt"
                    ? styles.adapt
                    : size === "small"
                      ? styles.small
                      : styles.standard
            } ${standardButton ? styles.normal_button : ""}            ${disabled ? styles.button_disable : styles.button}  ${
                grayClicked ? styles.grayed : ""
            } ${disabled ? styles.button_disable : ""} flex-container`}
            onMouseEnter={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
            onClick={onClickFuction}
            type={"button"}
            aria-label={`cancel button`}
            disabled={disableHTML}
        >
            {body ? (
                <span className={`${styles.body_text}`}>{body}</span>
            ) : (
                <>
                    <IconXmark className={`${styles.icon} icon-component`} />
                </>
            )}
        </button>
    );
};

export default CloseButton;
